import {
  USER_LOGIN,
  USER_CREATE,
  USER_RESET,
  USER_LOGOUT,
  USER_UPDATE,
} from './types'

// API
import * as API  from '../utils/api'

// Reset
const resetUser = () => ({
  type: USER_RESET
})

// Log Out
const logOutUser = () => ({
  type: USER_LOGOUT
})

export const resetUserState = () => dispatch => {
  dispatch(resetUser())
}

// Update
const updateUser = (user) => ({
  type: USER_UPDATE,
  user
})

export const updateUserState = (user) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(updateUser(user))

    let responseObject = {
      success: true
    }
    resolve(responseObject)
  })
}

export const updateUserAccountInfo = (user, accountInfoData) => dispatch => {
  return new Promise((resolve, reject) => {
    API.updateAuthenticatedUserAccountInfo(user, accountInfoData)
    .then(response => {
      if (response.errors) {
        reject('There was an error: ', response.errors)
      } else {
        let userUpdate = {
          first_name: response.first_name,
          last_name: response.last_name,
          phone_number: response.phone_number
        }

        dispatch(updateUser(userUpdate))

        let responseObject = {
          success: true
        }
        resolve(responseObject)
      }
    }).catch(error => {
      console.log('Error Caught: ', error)
    })
  })
}

export const getUpdatedUser = (user) => dispatch => {
  return new Promise((resolve, reject) => {
    API.getAuthenticatedUserInfo(user)
    .then(user => {
      dispatch(updateUser(user))

      let responseObject = {
        success: true
      }
      resolve(responseObject)
    })
  })
}

// Log Out
export const logOut = () => dispatch => {
  dispatch(logOutUser())
}

// Log In
const loggedIn = (user) => ({
  type: USER_LOGIN,
  user
})

export const logIn = (userData) => dispatch => {
  return new Promise((resolve, reject) => {
    API.login(userData)
      .then(response => {
        let responseObject = {}

        if (response.jwt) {
          let reduxUser = response.user

          reduxUser.auth_token = userData.auth_token
          reduxUser.isLoggedIn = true
          reduxUser.reduxLogInComplete = false
          reduxUser.auth_token = response.jwt

          dispatch(loggedIn(reduxUser))

          responseObject = {
            success: true,
            jwt: response.jwt,
            user: reduxUser
          }

          resolve(responseObject)
        } else {
          responseObject = {
            success: false,
            message: response.errors
          }
          resolve(responseObject)
        }
      })
  })
}

export const socialLogIn = (userData) => dispatch => {
  let user = {
    ...userData,
    isLoggedIn: true
  }

  dispatch(loggedIn(user))
}


// Sign Up
const signedUp = (user) => ({
  type: USER_CREATE,
  user
})

// Action for Manual Email Sign Up on SignUpForm.js
export const signUp = (userData) => dispatch => {
  return new Promise((resolve, reject) => {
    let responseObject = {}

    API.createMaintainer(userData)
    .then(response => {

      if (response.jwt) {
        const baseUserData = {
          isLoggedIn: true,
          role: userData.role,
          auth_token: response.jwt,
          isOnboarding: true
        }

        const user = userData.role === 'athlete'
        ? {
          ...baseUserData,
          first_name: userData.athlete_first_name,
          last_name: userData.athlete_last_name,
          email: userData.athlete_email,
          phone_number: userData.athlete_phone_number,
        }
        : {
          ...baseUserData,
          first_name: userData.parent_first_name,
          last_name: userData.parent_last_name,
          email: userData.parent_email,
          phone_number: userData.parent_phone_number,
        }

        dispatch(signedUp(user))

        responseObject = {
          success: true
        }
        resolve(responseObject)
      } else if (response.errors) {
        let responseObject = {
          success: false,
          message: response.errors[0]
        }
        resolve(responseObject)
      } else {
        let responseObject = {
          success: false,
          message: 'There was an error'
        }
        resolve(responseObject)
      }
    })
  })
}

export const signUpViaMaintainerInvite = (dataForSubmit, token) => dispatch => {
  return new Promise((resolve, reject) => {
    let responseObject = {}

    API.acceptMaintainerInvite(dataForSubmit, token)
    .then(response => {
      if (response.status === 200) {

        responseObject = {
          success: true
        }
        resolve(responseObject)
      } else {
        let responseObject = {
          success: false,
          message: response['user.email'] ? 'Email already used' : 'There was an error'
        }
        resolve(responseObject)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/actions/user.js